var VERSION = 1777427128813

export  {
	VERSION
} 
